import logoGfa from "./breazeShippingLogoGfa.txt?raw";

/** ZPL `^FO25,25^GFA…^FS` logo fragment (raw asset — keeps large hex out of TS source). */
export const BREAZE_SHIPPING_LOGO_ZPL = logoGfa.trim();
